<template>
  <div class="regions-tags mb-64">
    <h3 class="mb-24">{{ groupBoxTitle }}</h3>
    <div class="tags-wrapper">
      <div class="tags-wrapper__inner  custom-scrollbar">
        <div
          class="tag-btn-wrapper"
          v-for="(item, idx) in groupBoxData"
          :key="idx"
        >
          <a
            class="btn btn-sm btn-rnd btn-white text-truncate"
            :href="getUrl(item.url)"
            :title="item.title"
            :class="{ focused: item.current }"
            >{{ item.title }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "regions-tags",
  props: {
    groupBoxData: Array,
    groupBoxImage: String,
    groupBoxTitle: String
  },
  methods: {
    getUrl(url) {
      this.applyActiveLinkClass();
      return url;
    },
    applyActiveLinkClass() {
      let that = this;
      this.groupBoxData.forEach(function(value) {
        let url = value.url;

        if (url == that.$route.path) {
          value.current = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.regions-tags {
  border-top: 1px solid $border-color;
  padding-top: 32px;
}

.tags-wrapper {
  margin-left: -8px;
  margin-right: -8px;

  &__inner {
    @media (max-width: $screen-xs-max) {
      max-height: 300px;
      overflow-x: hidden;
      overflow-y: auto;
    }

    @media (min-width: $screen-xs) {
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.tag-btn-wrapper {
  padding: 8px;

  @media (min-width: $screen-xs) and (max-width: $screen-xs-max) {
    width: 50%;
  }

  .btn {
    @media (max-width: $screen-xs-max) {
      display: block;
      text-align: left;
    }
  }
}

.custom-scrollbar {
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: lighten($gray-20, 7%);
  }

  &::-webkit-scrollbar-thumb {
    background-color: darken($gray-20, 5%);
  }
}
</style>
